import { ref } from 'vue'

// Module-level ref — shared singleton state across all component instances
const showWalletModal = ref(false)

export function useWalletModal() {
    const openModal  = () => { showWalletModal.value = true  }
    const closeModal = () => { showWalletModal.value = false }
    return { showWalletModal, openModal, closeModal }
}
